<template>
  <v-autocomplete
    ref="auto"
    id="solution-select"
    v-model="filter.municipioTarefa"
    item-text="nome"
    item-value="municipioTarefaId"
    :items="tasks"
    :label="`${isAT ? 'Atividades' : 'Tarefa'}`"
    clearable
    :placeholder="`${isAT ? 'Atividades' : 'Tarefa'}`"
    :return-object="true"
    @change="change"
    @click="loadTasks"
    :loading="loading"
    @click:append="clickOnArrow"
  >
    <template slot="no-data">
      <div class="progress" v-if="loading">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>

      <div v-else>Nenhuma {{ isAT ? "Atividade" : "Tarefa" }} retornada</div>
    </template>
  </v-autocomplete>
</template>

<script>
import { cityTaskAPI } from "@/modules/city";
import { mapGetters, mapActions } from "vuex";
import { compare } from "@/helpers/orderByAsc";

export default {
  name: "AppCityTaskCombobox",
  props: ["filter"],
  computed: {
    ...mapGetters(["isAT"]),
  },
  data() {
    return {
      tasks: [],
      loading: false,
      municioTarefa: {},
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    change(value) {
      if (value) this.filter.municipioTarefa = value;
      else this.filter.municipioTarefa = {};

      this.$emit("changeTask");
    },
    clickOnArrow() {
      if (this.$refs.auto.isMenuActive == false)
        this.$refs.auto.$refs.input.click();
      else this.$refs.auto.isMenuActive = false;
    },
    loadTasks() {
      this.loading = true;
      this.tasks = [];
      var filtros = {
        grupoSolucaoId:
          this.filter.municipioGrupoSolucao &&
          this.filter.municipioGrupoSolucao.municipioGrupoSolucaoId,
        municipioId: this.$route.params.id,
        solucaoId:
          this.filter.municipioSolucao &&
          this.filter.municipioSolucao.municipioSolucaoId,
      };
      cityTaskAPI
        .listByCity(filtros)
        .then((resp) => {
          this.tasks = resp.data
            .filter((item) => item.desabilitado === false)
            .sort((a, b) => compare(a, b, "nome"));
          this.loading = false;
        })
        .catch((resp) => {
          this.loading = false;

          this.$notification.error(
            `Erro ao listar ${this.isAT ? "atividades" : "tarefas"}`
          );
        });
    },
  },
};
</script>
<style scoped>
.progress {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
